import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import './Navbar.css'
import '../UI/ChristmasBanner.css';

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <>

            <div className="navbar">
                {/* Menu Desktop */}
                <div className="navbar-container desktop-menu">
                    <div className="navbar-logo">
                        <img src="/logo_dark.png" alt="EchoNote Logo" />
                    </div>

                    <div className="navbar-links">
                        <a href="/">Home</a>
                    </div>

                    <div className="navbar-buttons">
                        <Link to="/login" className="no-style-link">
                            <button className="button-plain">
                                <span className="material-symbols-outlined icon">login</span>
                                Login
                            </button>
                        </Link>

                    </div>
                </div>

                {/* Menu Mobile */}
                <div className="mobile-menu">
                    <div className="mobile-menu-header">
                        <div className="navbar-logo">
                            <img src="/logo_dark.png" alt="EchoNote Logo" />
                        </div>
                        <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
                            <span className="material-symbols-outlined">
                                {isMobileMenuOpen ? 'close' : 'menu'}
                            </span>
                        </button>
                    </div>

                    {isMobileMenuOpen && (
                        <div className="mobile-menu-content">
                            <div className="mobile-links">
                                <a href="/">Home</a>
                            </div>
                            <div className="mobile-buttons">
                                <Link to="/login" className="no-style-link">
                                    <button className="button-plain">
                                        <span className="material-symbols-outlined icon">login</span>
                                        Login
                                    </button>
                                </Link>

                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Navbar;